import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bdcebe6c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcebe6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcebe6c')) {
      api.createRecord('bdcebe6c', component.options)
    } else {
      api.reload('bdcebe6c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bdcebe6c&scoped=true&", function () {
      api.rerender('bdcebe6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HwDNolf4SlRX/JS/comp/SearchFilterTokens.vue"
export default component.exports